/**
 * NutritionalProfileMethod - synchronized with the Prisma enum of the same name.
 *
 * How a nutritional profile was determined (Annex XV Reg. UE 1169/2011):
 * `DECLARED_LABEL` reports the values of a label/supplier sheet as declared;
 * `COMPUTED_COMPOSITION` is recomputed from the composition of component
 * ingredients. Only these two methods exist in T1.
 */
export const NUTRITIONAL_PROFILE_METHODS = ['DECLARED_LABEL', 'COMPUTED_COMPOSITION'] as const;
export type NutritionalProfileMethod = (typeof NUTRITIONAL_PROFILE_METHODS)[number];
